import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";

const ViewGenAiPrompt = Loadable(
  lazy(() =>
    import("./genAiPrompt/genAiPrompt").then(({ ViewGenAiPrompt }) => ({
      default: ViewGenAiPrompt,
    }))
  )
);

const ManageGenAiPrompt = Loadable(
  lazy(() =>
    import("./genAiPrompt/managegenAiPrompt").then(
      ({ ManageGenAiPrompt }) => ({
        default: ManageGenAiPrompt,
      })
    )
  )
);

const ViewGenAiContext = Loadable(
  lazy(() =>
    import("./genAiContext/genAiContext").then(({ ViewGenAiContext }) => ({
      default: ViewGenAiContext,
    }))
  )
);

const ManageGenAiContext = Loadable(
  lazy(() =>
    import("./genAiContext/managegenAiContext").then(
      ({ ManageGenAiContext }) => ({
        default: ManageGenAiContext,
      })
    )
  )
);

const GenAiKnowledgeBase = Loadable(
  lazy(() =>
    import("./GenAiKnowledgeBase/GenAiKnowledgeBase").then(
      ({ GenAiKnowledgeBase }) => ({
        default: GenAiKnowledgeBase,
      })
    )
  )
);

const AIScopePage = Loadable(
  lazy(() =>
    import("./AIScope").then(({ AIScope }) => ({
      default: AIScope,
    }))
  )
);

const ActionItemCategory = Loadable(
  lazy(() =>
    import("./ActionItemCategory/ActionItemCategory").then(
      ({ ActionItemCategory }) => ({
        default: ActionItemCategory,
      })
    )
  )
);

const Intents = Loadable(
  lazy(() =>
    import("./Intents/Intents").then(({ Intents }) => ({
      default: Intents,
    }))
  )
);

const AgentTools = Loadable(
  lazy(() =>
    import("./AgentTools/AgentTools").then(({ AgentTools }) => ({
      default: AgentTools,
    }))
  )
);

const DebugPage = Loadable(
  lazy(() =>
    import("./Debug/Debug").then(({ Debug }) => ({
      default: Debug,
    }))
  )
);

export const genAiRoutes = [
  {
    path: "/gen-ai-prompt",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[]} allowFullAccess>
        <ViewGenAiPrompt />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/gen-ai-prompt/manage",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[]} allowFullAccess>
        <ManageGenAiPrompt />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/gen-ai-prompt/manage/:genAiPromptId",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[]} allowFullAccess>
        <ManageGenAiPrompt />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/gen-ai-context",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[]} allowFullAccess>
        <ViewGenAiContext />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/gen-ai-context/manage",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[]} allowFullAccess>
        <ManageGenAiContext />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/gen-ai-context/manage/:genAiContextId",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[]} allowFullAccess>
        <ManageGenAiContext />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/gen-ai-knowledge-base",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[]} allowFullAccess>
        <GenAiKnowledgeBase />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/ai-scope",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[]} allowFullAccess>
        <AIScopePage />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/action-item-category",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[]} allowFullAccess>
        <ActionItemCategory />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/intents",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[]} allowFullAccess>
        <Intents />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/agent-tools",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[]} allowFullAccess>
        <AgentTools />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/debug",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[]} allowFullAccess>
        <DebugPage />
      </AuthorizedRoute>
    ),
  },
];
